import { Component } from '@angular/core';
import { BaseViewEntityComponent } from '@cl/core/components/base-view-entity.component';
import { Document } from '@cl/shared/models';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-view-document',
    standalone: false,
    templateUrl: './view-document.component.html',
    styleUrl: './view-document.component.less',
})
export class ViewDocumentComponent extends BaseViewEntityComponent<Document> {
    constructor(protected modalRef: NzModalRef) {
        super(modalRef);
    }
}
